import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { useNavigate } from "react-router-dom";

type RedirectBackButtonProps = {
  redirectRoute: string;
  labelKey: string;
  labelValues?: Record<string, string>;
  color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
  icon?: React.ReactNode;
  style?: React.CSSProperties;
  onRedirectBack?: () => void;
};

const RedirectBackButton = ({
  redirectRoute,
  labelKey,
  labelValues,
  color = "primary",
  icon = <ArrowBackIcon />,
  style,
  onRedirectBack,
}: RedirectBackButtonProps) => {
  const navigate = useNavigate();
  return (
    <>
      <Button
        color={color}
        onClick={() =>
          onRedirectBack ? onRedirectBack() : navigate(redirectRoute)
        }
        startIcon={icon}
        style={style}
        data-cy={`${labelKey}`}
      >
        <T id={labelKey} values={labelValues} />
      </Button>
    </>
  );
};

export default RedirectBackButton;
